<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <b-card>
      <div class="heading">
        <span class="h4">{{ $t("Relatives") }}</span>
        <feather-icon
          id="export"
          icon="DownloadCloudIcon"
          svgClasses="w-5 h-5 hover:text-danger stroke-current"
          class="ml-5"
          :title="$t('Export')"
          v-b-modal.modal-1
        />
        <router-link :to="'/company/users'" class="float-right">
          <b-button variant="primary" class="primary">{{
            $t("Back")
          }}</b-button>
        </router-link>
      </div>

      <b-modal
        id="modal-1"
        :title="$t('ExportToExcel')"
        :ok-title="$t('Export')"
        :cancel-title="$t('Cancel')"
        @ok="exportToExcel"
        @cancel="clearFields"
        @close="clearFields"
        class="export-options"
        centered
      >
        <b-input
          v-model="fileName"
          :placeholder="$t('FileName')"
          class="w-full"
        />
        <v-select v-model="selectedFormat" :options="formats" class="my-4"
          ><template v-slot:option="option">
            <span :class="option.icon">{{ option.label }} </span>
            <feather-icon
              v-if="selectedFormat == option.label"
              icon="CheckIcon"
              class="float-right"
              svgClasses="w-5 h-5"
            />
          </template>
        </v-select>
        <div class="flex walk-card">
          <span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
          <b-form-checkbox
            v-model="cellAutoWidth"
            size="lg"
            name="cell_width"
            switch
          >
          </b-form-checkbox>
        </div>
      </b-modal>

      <div class="export-table">
        <b-col lg="5" class="my-1 p-2 float-right">
          <b-form-group
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="md">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                :placeholder="$t('Search')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          :current-page="currentPage"
          :per-page="perPage"
          :items="users"
          :fields="fields"
          :busy="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          responsive
          show-empty
          :filter="filter"
          :filter-included-fields="filterOn"
          :empty-text="$t('EmptyData')"
          :empty-filtered-text="$t('EmptyFilter')"
          @filtered="onFiltered"
        >
          <template #head()="data">
            <span>{{ $t(data.label) }}</span>
          </template>
          <template #cell()="data">
            <span>{{ $t(data.value) }}</span>
          </template>
          <template #cell(status)="data">
            <span v-if="data.item.status == 0 || data.item.status == null">{{
              $t("Pending")
            }}</span>
            <span v-if="data.item.status == 1">{{ $t("Accepted") }}</span>
            <span v-if="data.item.status == 2">{{ $t("Rejected") }}</span>
          </template>
          <template #cell(relation)="data">
            <span>{{ $t(data.item.relation) }}</span>
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-b-tooltip.hover
              :title="$t('View')"
              icon="EyeIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="
                $router.push('/company/user/relatives/show/' + data.item.id)
              "
            />
            <feather-icon
              v-if="data.item.status == 0"
              v-b-tooltip.hover
              :title="$t('Accept')"
              icon="CheckIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="updateStatus(data.item.id, 1)"
            />
            <feather-icon
              v-if="data.item.status == 0"
              v-b-tooltip.hover
              :title="$t('Reject')"
              icon="XIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="updateStatus(data.item.id, 2)"
            />
          </template>
        </b-table>
        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          class="float-right"
        ></b-pagination>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: [
        this.$t("FirstName"),
        this.$t("LastName"),
        this.$t("DegreeOfKinship"),
        this.$t("DateOfBirth"),
        this.$t("BirthPlace"),
        this.$t("Status"),
      ],
      headerVal: [
        "first_name",
        "last_name",
        "degree_of_kinship",
        "date_of_birth",
        "birth_place",
        "status",
      ],
      users: [],
      activePrompt: false,
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      totalRows: 1,
      fields: [
        {
          key: "first_name",
          label: "FirstName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "last_name",
          label: "LastName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "degree_of_kinship",
          label: "DegreeOfKinship",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "status",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "action", label: "Action" },
      ],
    };
  },
  computed: {
    rows() {
      return this.users.length;
    },
  },
  created() {
    this.getRelatives();
  },

  watch: {
    rejectMessage(value) {
      if (value != "") {
        this.checkReject = true;
      } else {
        this.checkReject = false;
      }
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.users;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        (this.headerTitle = [
          $t("FirstName"),
          $t("LastName"),
          $t("DegreeOfKinship"),
          $t("DateOfBirth"),
          $t("BirthPlace"),
          $t("Status"),
        ]),
          this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.filename = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    /**
     *
     * getUsers   method  for list all users data
     **/
    getRelatives() {
      this.show = true;

      this.$store
        .dispatch("getRelatives", this.$route.params.id)
        .then((res) => {
          this.show = false;
          this.users = res.data.data;
          this.totalRows = this.users.length;  
          if (this.users.length) {
            let user_list = this.users;
            this.users.forEach((element, index) => {
              let relation =
                element.degree_of_kinship.charAt(0).toUpperCase() +
                this.users[index].degree_of_kinship.slice(1);
              user_list[index].degree_of_kinship = relation
                .replace(/[^a-zA-Z ]/g, "")
                .replace(/ /g, "");
              console.log(relation);
            });
            this.users = user_list;
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getUsers() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     *
     * update status to Accept or Reject
     **/
    updateStatus(id, status) {
      this.show = true;
      let data = {
        status: status,
        id: id,
        company_id: this.$store.getters.currentUser.id,
      };
      this.$store
        .dispatch("updateRelativeStatus", data)
        .then((res) => {
          this.show = false;
          this.getRelatives();
          this.rejectMessage = "";
          this.$toasted.show(this.$t("StatusUpdated"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : updateStatus() | Error :",
            error
          );
          this.show = false;
          // Error response
          return false;
        });
    },

    rejectUser(id, status) {
      this.popupActivo2 = true;
      this.reject_id = id;
      this.reject_status = status;
    },

    submitRejectForm() {
      if (this.checkReject) {
        this.updateStatus(this.reject_id, this.reject_status);
      }
    },

    close() {
      this.rejectMessage = "";
      this.checkReject = false;
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}
</style>